module.exports = __webpack_public_path__ + "img/mv.0fdc08c6.svg";